export default {
  form: {
    firstName: 'First name',
    firstNamePlaceholder: 'Enter first name',
    lastName: 'Surname',
    lastNamePlaceholder: 'Enter surname',
    email: 'Email address',
    emailPlaceholder: 'Enter email address',
    personalNumber: 'Personal number',
    birthYear: 'Year of birth',
    biologicalGender: 'Biological sex',
    geneticGender: 'Genetic sex',
    department: 'Department',
    departmentPlaceholder: 'Enter department, e.g. HR, IT, Sales',
    market: 'Market',
    continue: 'Continue',
    add: 'Add',
    save: 'Save',
    saveChanges: 'Save changes',
    changesSaved: 'Changes saved',
    saveError: 'Something went wrong when saving your changes!',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    chooseOption: 'Select an option',
    choose: 'Select...',
    language: 'Language',
    next: 'Next',
    close: 'Close',
    loading: 'Sending...',
    skip: 'Skip',
  },
  market: {
    sweden: 'Sweden',
    norway: 'Norway',
  },
  validation: {
    firstNameRequired: 'First name required',
    lastNameRequired: 'Surname required',
    emailRequired: 'Email address required',
    invalidEmail: 'Invalid email address',
    invalidLanguage: 'Please select a valid language.',
    invalidMarket: 'Please select a valid market.',
    departmentTooLong: 'Department must not exceed 100 characters',
  },
  gender: {
    female: 'Female',
    male: 'Male',
    preferNotToSay: 'Prefer not to say',
  },
  errors: {
    somethingWentWrong: 'Something went wrong! Please try again or contact support at support@estercare.com',
    tryAgainOrContact: 'Something went wrong when trying to add the employee. Please try again.',
    networkBlocked:
      'This feature is not supported on your network. Please try from another network or contact support at support@estercare.com.',
    ssoOrgNotConfigured: "Your employer hasn't activated EsterCare yet.",
    ssoLoginFailed:
      "We couldn't log you in through your benefits portal. Please try again or contact support at support@estercare.com",
    ssoUseSsoLogin: 'This account signs in through your employer. Open EsterCare through your benefits portal.',
    ssoUsePasswordLogin: 'This account signs in with email and password. Sign in to the portal the usual way.',
    ssoAccountConflict:
      "This account can't be used to sign in through your benefits portal. Please contact support at support@estercare.com",
  },
  navigation: {
    home: 'Home',
    overview: 'Overview',
    services: 'Services',
    healthCalls: 'Health Calls',
    screening: 'Screening',
    messages: 'Chat',
    statistics: 'Statistics',
    employees: 'Employees',
    billing: 'Billing',
    support: 'Support',
    training: 'Training',
    knowledgeBank: 'Resource Centre',
    yourHealth: 'Your Health Plan',
    myAccount: 'My Account',
    logout: 'Log Out',
  },
  file: {
    needsTwoRows: 'The file must contain at least two rows of data.',
    needsThreeColumns: 'The file must contain at least three columns: Email, first name and surname.',
    missingValues: 'One or more rows are missing values in one or more columns.',
    invalidEmails: 'Invalid email address in one or more rows.',
    fileValid: 'The file is valid.',
    managerColumnFormat: 'The column for managerial position must be specified as a "true" or "false" value.',
    languageColumnFormat:
      'The language column must be specified as "sv" for Swedish, "en" for English, or "nb" for Norwegian.',
    invalidLanguage: 'Please select a valid language.',
    dragFileHere: 'Drag the file here or click in the box to import.',
    dropFileHere: 'Drop the file here...',
    fileTypeNotSupported: 'This file type is not supported.',
    uploadingFile: 'Uploading file...',
    uploadFailed: 'File upload failed, please try again.',
    uploadComplete: 'Upload complete!',
  },
  table: {
    name: 'Name',
    added: 'Added',
    lastLogin: 'Last login',
  },
  menu: {
    removeUser: 'Remove user',
    removeAdminRights: 'Remove admin rights',
    giveAdminRights: 'Grant admin rights',
    removeManagerRights: 'Remove managerial responsibilities',
    addManagerRights: 'Add managerial responsibilities',
    clearScreening: 'Clear my screening',
    esterInvite: 'Invited by ',
  },
  alerts: {
    screeningCleared: 'Your screening has been cleared',
  },
  welcome: {
    greeting: 'Hello {{firstName}}!',
    title: 'Welcome to EsterCare´s Health Portal',
    subtitle: 'To get started, we need to know a bit more about you.',
    zipCode: 'Your postcode',
    errorZipCode: 'Incorrect postcode format',
    errorBirthYear: 'Incorrect date of birth format',
    isManager: 'I have managerial responsibilities',
  },
  notFound: {
    title: "The page you're looking for <br /> doesn't exist",
    imageAlt: 'Three women in conversation (illustration)',
    backToHome: 'Return to our homepage',
  },
  loggedOut: {
    message: 'You are logged out. Open EsterCare through your benefits portal again.',
  },
  addEmployee: {
    title: 'Add employee',
    addMultipleTitle: 'Add multiple employees',
    addMultipleDescription: 'Add multiple employees simultaneously by listing them in a CSV file.',
    templateInstruction: 'Use our template to format the file correctly.',
    assignManagerRights: 'Assign manager rights?',
    wantToAddMany: 'Would you like to add multiple employees?',
    wantToAddOne: 'Would you like to add just one employee?',
  },
  content: {
    morePodcasts: 'More podcast episodes',
    moreArticles: 'More articles',
    showMore: 'Show more',
    toKnowledgeBank: 'To our Resource Centre',
    article: 'Article',
    podcast: 'Podcast',
    episode: 'Episode',
    webinar: 'Webinar',
    missingDescription: 'Description missing',
    writtenBy: 'This article is written by:',
    onlyAvailableInSwedish: 'Only available in Swedish',
  },
  faq: {
    title: 'Frequently Asked Questions',
    noAnswerText: "Can't find the answer you're looking for?",
    visitSupport: 'Visit support',
  },
  training: {
    confirmCancel: 'Are you sure you want to cancel?',
    progressNotSaved: 'If you leave the training now, your progress will not be saved.',
    continueTraining: 'No, continue training',
    cancelAndLeave: 'Yes, cancel and leave',
    duration: 'Duration',
    minutes: 'min',
    completed: 'Completed',
    listenSpotify: 'Listen via Spotify',
  },
  roles: {
    admin: 'Admin',
    employee: 'Employee',
    adminTag: 'ADMIN',
    managerTag: 'MANAGERIAL RESPONSIBILITIES',
    invitedTag: 'INVITED',
  },
  service: {
    active: 'Active',
    readMore: 'Read more',
  },
  statistics: {
    trainingNotStarted: 'Training not started',
    trainingInProgress: 'Training in progress',
    trainingCompleted: 'Training completed',
  },
  language: {
    swedish: 'Swedish',
    english: 'English',
    norwegian: 'Norwegian',
  },
  other: {
    yourOrganisation: 'your organisation',
  },
  dataPolicy: {
    title: 'How we handle your data',
    titleUpdated: 'We have updated our data protection policy',
    ingress:
      'Here is our full data protection policy for the health portal. You can always find it again under your profile.',
    summary:
      'Our data protection policy describes how EsterCare handles your personal data in the health portal. In short: your organisation never sees your answers, your health plan or your messages.',
    summaryUpdated: 'We have made changes to how we describe our handling of your personal data in the health portal.',
    readPolicy: 'Read the data protection policy',
    compactHint: 'You can always find the policy again under your profile.',
    readMore: 'Read more',
    ingressUpdated:
      'We have made changes to how we describe our handling of your personal data. Read through the new version and confirm to continue.',
    whatsNew: "What's new in version {{version}}",
    versionLine: 'Version {{version}} · Effective from {{date}}',
    openInNewWindow: 'Open in new window',
    loggedInAs: 'Logged in as',
    hint: 'This confirms that you have read the information. We ask for consent to process your health data separately, before the screening.',
    acknowledge: 'I have read the information',
    decline: 'Decline',
    declineTitle: 'Do you want to decline?',
    declineBody:
      'You need to confirm that you have read the data protection policy to use the health portal. If you decline, you will be logged out. Your account remains and you can come back at any time.',
    declineConfirm: 'Decline and log out',
    declineBack: 'Back to the policy',
    declinedTitle: 'You are now logged out',
    declinedBody:
      "You need to confirm that you have read our data protection policy to use EsterCare's health portal. You are now logged out and can come back at any time. If you want your account removed, contact your organisation or support@estercare.com.",
    loginAgain: 'Log in again',
    menuLink: 'Data protection policy',
    loadError: 'We could not load the policy. Please try again in a moment.',
    submitError: 'Something went wrong. Please try again.',
    retry: 'Try again',
  },
} as const
